import { render } from "./videoPlayer.vue?vue&type=template&id=1e8cb47e&scoped=true"
import script from "./videoPlayer.vue?vue&type=script&lang=js"
export * from "./videoPlayer.vue?vue&type=script&lang=js"

import "./videoPlayer.vue?vue&type=style&index=0&id=1e8cb47e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8cb47e"]])

export default __exports__